import React, { Component } from "react";
import Global from "../../Global";
import "./alertBox.css";

export default class AlertBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertMessage: {
        show: true,
        message: "",
      },
    };
  }

  componentWillMount() {
    var url = Global.getAPI("top-navigation");
    var self = this;
    fetch(url)
      .then(function(response) {
        if (response.status >= 400) {
          throw new Error("Error API: topnav");
        }
        return response.json();
      })
      .then(function(data) {
        let alertMessage = {
          show: data.general && data.general.alertBox,
          message: data.general.alertBoxMessage && data.general.alertBoxMessage,
        };
        self.setState(
          {
            alertMessage,
          },
          (_) => {}
        );
      });
  }

  close() {
    this.setState({
      alertMessage: { ...this.state.alertMessage, show: false },
    });
  }

  render() {
    const { alertMessage } = this.state;
    const { show } = alertMessage;
    const size = 15;

    if (!show) return null;

    return (
      <div data-nosnippet className={"alertBox"}>
        <div
          data-nosnippet
          className={"text-block"}
          dangerouslySetInnerHTML={{ __html: alertMessage.message || "" }}
        />

        <div className="container-alert-box-close">
          <svg
            onClick={() => this.close()}
            className={"close"}
            xmlns="http://www.w3.org/2000/svg"
            fill="#fff"
            viewBox="0 0 100 100"
            xmlSpace="preserve"
          >
            <circle
              cx="50"
              cy="50"
              r="35"
              stroke="black"
              strokeWidth="0"
              fill="white"
            />
            <line
              x1={50 - size}
              y1={50 - size}
              x2={50 + size}
              y2={50 + size}
              stroke={"black"}
              strokeWidth={12}
            />
            <line
              x1={50 - size}
              y1={50 + size}
              x2={50 + size}
              y2={50 - size}
              stroke={"black"}
              strokeWidth={12}
            />
          </svg>
        </div>
      </div>
    );
  }
}
